import { SETMEGAMENUACTIVELEVEL } from 'redux/modules/page/actions/types';

export const setMegaMenuActiveLevel = level => ({
  type: SETMEGAMENUACTIVELEVEL,
  level,
});
